import React from "react"
import { Link, NavLink } from "react-router-dom"
import avatarImg from "../assets/images/avatar-icon.png"

export default function Header() {
  const activeStyles = {
    fontWeight: "bold",
    textDecoration: "underline",
    color: "#161616"
  }

  function fakeLogOut() {
    localStorage.removeItem("loggedin")
  }

  return (
    <header>
      <Link className="site-logo" to="/">#VanLife</Link>
      <nav>
        <NavLink
          to="host"
          style={({ isActive }) => isActive ? activeStyles : null}
        >
          Host
        </NavLink>
        <NavLink
          to="about"
          style={({ isActive }) => isActive ? activeStyles : null}
        >
          About
        </NavLink>
        <NavLink
          to="vans"
          style={({ isActive }) => isActive ? activeStyles : null}
        >
          Vans
        </NavLink>
        <Link to="login" className="login-link">
          <img
            src={avatarImg}
            className="login-icon"
            alt="avatar-img"
          />
        </Link>
        <button onClick={fakeLogOut}>X</button>
      </nav>
    </header>
  )
}